import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.5 7.25V8.75H8.75V15.5H7.25V8.75H0.5V7.25H7.25V0.5H8.75V7.25H15.5Z",
		fill: "currentColor"
	})
});
export default SvgPlusIcon;
